// Classes
import { DemographicsReducerState } from "Containers/Filter/Demographics/classes/demographics.classes";
import { AttributeObject } from "../classes/attributes.classes";

/**
 * @function getVisitorTypeAttributes
 *
 * Post-processes the attributes for this section of the filter
 *
 * @param {DemographicsReducerState} demographics - The current state
 * of the Demographics filter section.
 * @return {AttributeObject | undefined}
 *
 * @example
 *
 *     getVisitorTypeAttributes(demographics)
 */
export const getVisitorTypeAttributes = (
  demographics: DemographicsReducerState
) => {
  const attributeArray = [
    (demographics.visitorType.prospectiveStudents.hsStudent &&
      "High School Students") ||
      undefined,
    (demographics.visitorType.prospectiveStudents.hsFreshman &&
      "High School Freshmen") ||
      undefined,
    (demographics.visitorType.prospectiveStudents.hsSophomore &&
      "High School Sophomores") ||
      undefined,
    (demographics.visitorType.prospectiveStudents.hsJunior &&
      "High School Juniors") ||
      undefined,
    (demographics.visitorType.prospectiveStudents.hsSenior &&
      "High School Seniors") ||
      undefined,
    (demographics.visitorType.prospectiveStudents.hsGraduate &&
      "High School Graduates") ||
      undefined,
    (demographics.visitorType.prospectiveStudents.collegeStudent &&
      "College Students") ||
      undefined,
    (demographics.visitorType.prospectiveStudents.collegeGraduate &&
      "College Graduates") ||
      undefined,
    (demographics.visitorType.prospectiveStudents.adultLearner &&
      "Adult Learners") ||
      undefined,
    (demographics.visitorType.prospectiveStudents.middleSchooler &&
      "Middle Schoolers") ||
      undefined,
    (demographics.visitorType.parentsOfProspects.hsStudent &&
      "Parents of High School Student") ||
      undefined,
    (demographics.visitorType.parentsOfProspects.hsFreshman &&
      "Parents of High School Freshman") ||
      undefined,
    (demographics.visitorType.parentsOfProspects.hsSophomore &&
      "Parents of High School Sophomore") ||
      undefined,
    (demographics.visitorType.parentsOfProspects.hsJunior &&
      "Parents of High School Junior") ||
      undefined,
    (demographics.visitorType.parentsOfProspects.hsSenior &&
      "Parents of High School Senior") ||
      undefined,
    (demographics.visitorType.parentsOfProspects.hsGraduate &&
      "Parents of High School Graduate") ||
      undefined,
    (demographics.visitorType.parentsOfProspects.collegeStudent &&
      "Parents of College Student") ||
      undefined,
    (demographics.visitorType.parentsOfProspects.collegeGraduate &&
      "Parents of College Graduate") ||
      undefined,
    (demographics.visitorType.parentsOfProspects.middleSchooler &&
      "Parents of Middle Schooler") ||
      undefined,
    (demographics.visitorType.currentStudent && "Current Students") ||
      undefined,
    (demographics.visitorType.alumni && "Alumni") || undefined,
    (demographics.visitorType.faculty && "Faculty") || undefined,
    (demographics.visitorType.guidanceCounselor && "Guidance Counselors") ||
      undefined,
    (demographics.visitorType.veteran && "Veterans") || undefined
  ].filter(attributeObject => typeof attributeObject !== "undefined");

  let attributeObject: any;

  if (attributeArray.length > 0) {
    attributeObject = new AttributeObject(
      (attributeArray.length > 1 && `Visitor Type=${attributeArray.length}`) ||
        attributeArray[0],
      "standard",
      attributeArray.length > 1 && attributeArray
    );
  } else {
    attributeObject = undefined;
  }

  return attributeObject;
};
try {
    // @ts-ignore
    getVisitorTypeAttributes.displayName = "getVisitorTypeAttributes";
    // @ts-ignore
    getVisitorTypeAttributes.__docgenInfo = { "description": "", "displayName": "getVisitorTypeAttributes", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Attributes/utilities/getVisitorTypeAttributes.ts#getVisitorTypeAttributes"] = { docgenInfo: getVisitorTypeAttributes.__docgenInfo, name: "getVisitorTypeAttributes", path: "src/shared/containers/Attributes/utilities/getVisitorTypeAttributes.ts#getVisitorTypeAttributes" };
}
catch (__react_docgen_typescript_loader_error) { }